import { Link } from 'react-router-dom'
import ScreenHolder from '../../Partials/Layouts/ScreenHolder/ScreenHolder'

function OrganizationScreens() {
  return (
    <ScreenHolder>
        <div>
            <div>
            <Link to={'/organizations'} >Organizations</Link>
            </div>
        
        </div>
    </ScreenHolder>
  )
}

export default OrganizationScreens